<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="close">
    <div class="modal-container">
      <div class="modal-header bg-success">
        <h5 class="modal-title">{{ title }}</h5>
        <button type="button" class="close-btn" @click="close">&times;</button>
      </div>
      <div class="modal-body text-center">
        <div class="icon-wrapper">
          <i class="mdi mdi-check-circle-outline success-icon"></i>
        </div>
        <h4 class="success-heading">{{ heading }}</h4>
        <p class="success-message">{{ message }}</p>
      </div>
      <div class="modal-footer">
        <button class="btn-success" @click="close">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessModal',
  props: {
    title: { type: String, default: 'Success' },
    heading: { type: String, default: 'Operation Successful!' },
    message: { type: String, default: '' }
  },
  data() {
    return {
      isVisible: false
    };
  },
  methods: {
    open() {
      this.isVisible = true;
      
      // Auto close after 3 seconds
      setTimeout(() => {
        if (this.isVisible) {
          this.close();
        }
      }, 3000);
    },
    close() {
      this.isVisible = false;
      this.$emit('closed');
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-container {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: slideIn 0.3s ease;
}

.modal-header {
  padding: 16px 20px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bg-success {
  background-color: #28a745;
}

.modal-title {
  color: white;
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 28px;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.modal-body {
  padding: 30px 20px;
  text-align: center;
}

.icon-wrapper {
  margin-bottom: 20px;
}

.success-icon {
  font-size: 64px;
  color: #28a745;
}

.success-heading {
  color: #28a745;
  margin: 10px 0 8px;
  font-size: 1.5rem;
}

.success-message {
  color: #6c757d;
  margin: 0;
  font-size: 1rem;
}

.modal-footer {
  padding: 16px 20px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: center;
}

.btn-success {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 10px 40px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
}

.btn-success:hover {
  background-color: #218838;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>